import { getFragmentData } from '@e-socna/data-layer';
import type { FragmentType, Id } from '@e-socna/data-layer';

import type { ServiceUsagesTotalCardCmp_TotalCalculation_Fragment } from '../components/ServiceUsages/TotalCard';
import { ServiceUsagesTotalCardCmp_GroupTotalCalculation_Fragment } from '../components/ServiceUsages/TotalCard';

// A null total is one the user may not read.
export type GroupTotalCalculationMap = ReadonlyMap<
  Id,
  FragmentType<
    typeof ServiceUsagesTotalCardCmp_TotalCalculation_Fragment
  > | null
>;

export const buildGroupTotalCalculationMap = (
  groupTotalCalculations:
    | readonly FragmentType<
        typeof ServiceUsagesTotalCardCmp_GroupTotalCalculation_Fragment
      >[]
    | null
    | undefined,
): GroupTotalCalculationMap => {
  const resolved = getFragmentData(
    ServiceUsagesTotalCardCmp_GroupTotalCalculation_Fragment,
    groupTotalCalculations ?? [],
  );

  return new Map(
    resolved.map(({ groupId, totalCalculation }) => [
      groupId,
      totalCalculation,
    ]),
  );
};
